<template>
	<PageDefault size="narrow">
		<div v-if="resetSend == false">
			<h1>Відновлення паролю</h1> 
			<p>
				Після надсилання запиту на відновлення паролю, вам прийде лист
				на вказану електронну пошту з інструкціями.
			</p>
			<input 
				v-model="email" 
				type="email" 
				placeholder="Введіть ваш e-mail" 
				:class="{ invalid: email.length > 0 && !isEmailValid(email) }"
				class="text-box"
			>
			<br/>
	
			<div>
				<button 
					class="btn" 
					@click="resetClick"
				>
					Відновити пароль
				</button>
			</div>
		</div>
		<div v-if="resetSend == true">
			<h1>Відновлення паролю</h1> 
			<p>
				Запит було надіслано на вашу електронну пошту. 
				Обов'язково перевірте теку зі спамом! 
			</p>
		</div>
	</PageDefault>
</template>

<script setup>
import { ref } from 'vue'
import axios from 'axios'

import PageDefault from '@/components/ui/PageDefault.vue'

import { isEmailValid } from '@/modules/DataValidation'

const email = ref("")

const resetSend = ref(false)

async function resetClick()
{
	if (!isEmailValid(email.value)) {
		window.alert("Перевірте правильність введених даних")
		return
	}

	try {
		const response = await axios.post(`/api/v1/auth/password-recovery?email=${email.value}`)
		if (response.status == 200) {
			resetSend.value = true
		}
	} catch (error) {
		console.error('Error: ', error)
		window.alert("Помилка. Перевірте правильність введених даних.")
	}
}
</script>

<style scoped>
.dark .text-box.invalid {
	background-color: #7c2f2f;
}
.text-box.invalid {
	background-color: #d47272;
}
</style>